import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { validType } from 'const';
import { IconButton } from 'styles/util';
/**
 * 管理者アカウントの行を表示するコンポーネント
 */
const Account = (props) => {
  const { item } = props;
  return (
    <tr>
      <td>
        <Link to={`/adm/account/detail/${item.sub}`}>
          {item.name}
        </Link>
      </td>
      <td>{item.email}</td>
      <td>{item.phone_number}</td>
      <td>{validType[item.enabled]}</td>
      <td>{item.user_status}</td>
      <td>
        <IconButton>
          <Link to={`/adm/account/edit/${item.sub}`} style={{color: 'black'}}>
            <i className="fa fa-edit" aria-hidden="true"></i>
          </Link>
        </IconButton>
      </td>
    </tr>  
  );
};
Account.propTypes = {
  item: PropTypes.object
};
Account.defaultProps = {
  item: {
    name: '',
    email: '',
    phone_number: '',
    enabled: false,
    user_status: '',
  }
};
export default Account;